import { createSlice } from '@reduxjs/toolkit'

export const onLoadActivitiesReducer = (state, { payload }) => {
  const { activities } = payload

  const newState = {
    ...state,
    activities
  }
  return newState
}

export const onSaveActivityReducer = (state, { payload }) => {
  const { activity } = payload

  const newState = {
    ...state,
    activity
  }
  return newState
}

export const onNewActivityReducer = (state, payload) => {
  const isNew = payload.payload

  const newState = {
    ...state,
    activity: {
      name: '',
      prodcuts: [],
      steps: [
        {
          description: '',
          title: '',
          littlebitsId: 0,
          position: 0
        }
      ]
    },
    isNew
  }

  return newState
}

export const onSaveActivityStepsReducer = (state, { payload }) => {
  const { steps } = payload
  const newState = {
    ...state,
    activity: {
      ...state.activity,
      steps
    }
  }

  return newState
}

export const onSaveProductsReducer = (state, { payload }) => {
  const { products } = payload

  return {
    ...state,
    activity: {
      ...state.activity,
      products
    }
  }
}

export const onSaveLinkedProgramReducer = (state, { payload }) => {
  const { program } = payload

  return {
    ...state,
    activity: {
      ...state.activity,
      program
    }
  }
}

export const onSaveAnswersReducer = (state, { payload }) => {
  const { answers, progress } = payload

  return {
    ...state,
    activity: {
      ...state.activity,
      assignment: {
        ...state.activity.assignment,
        progress,
        answers
      }
    }
  }
}

export const onSaveGradesReducer = (state, { payload }) => {
  const { grades } = payload

  return {
    ...state,
    activity: {
      ...state.activity,
      grades
    }
  }
}

export const onSaveQueryIdReducer = (state, { payload }) => {
  const { activityId, lessonId } = payload

  return {
    ...state,
    activityId,
    lessonId
  }
}

export const onClearActivityReducer = () => {
  return {
    activity: {
      products: [],
      tags: {}
    },
    isNew: false,
    stepsState: []
  }
}

const activitySlice = createSlice({
  name: 'activity',
  initialState: {
    activity: {
      products: [],
      tags: {},
      grades: []
    },
    assignment: {},
    isNew: false,
    lessonId: '',
    activityId: ''
  },
  reducers: {
    onLoadActivities: onLoadActivitiesReducer,
    onSaveActivity: onSaveActivityReducer,
    onNewActivity: onNewActivityReducer,
    onSaveActivitySteps: onSaveActivityStepsReducer,
    onSaveAnswers: onSaveAnswersReducer,
    onSaveProducts: onSaveProductsReducer,
    onSaveLinkedProgram: onSaveLinkedProgramReducer,
    onSaveGrades: onSaveGradesReducer,
    onClearActivity: onClearActivityReducer,
    onSaveQueryId: onSaveQueryIdReducer
  }
})

const { actions, reducer } = activitySlice

export const {
  onLoadActivities,
  onSaveActivity,
  onNewActivity,
  onSaveActivitySteps,
  updateStepsState,
  onForceStepSave,
  onSaveAnswers,
  onSaveProducts,
  onSaveLinkedProgram,
  onSaveGrades,
  onClearActivity,
  onSaveQueryId
} = actions

export default reducer
